import { render } from "./About.vue?vue&type=template&id=03e2d06c"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=03e2d06c&lang=css"
script.render = render

export default script